import React, { useEffect } from "react";

const Contact = () => {
  useEffect(() => {
    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      const scrollY = window.scrollY;

      const animatables = document.querySelectorAll('.animatable');

      animatables.forEach(animatable => {
        const elementTop = animatable.getBoundingClientRect().top + scrollY;
        const elementBottom = elementTop + animatable.clientHeight;

        // Check if element is in the viewport
        if (scrollY + windowHeight > elementTop && scrollY < elementBottom) {
          animatable.classList.add('animated');
          animatable.classList.remove('animatable');
        } else {
          // Reset the animation when the element is out of view
          animatable.classList.remove('animated');
          animatable.classList.add('animatable');
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Trigger animation on mount

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      <h1 className="box-title block animatable bounceIn">Contact Us</h1>

      <div className="contact-container">
        {/* Left Section */}
        <div className="contact-info block animatable bounceInLeft">
          <h2 className="contact-title block animatable bounceIn">Our Information</h2>
          <p className="contact-detail">
            <span role="img" aria-label="location">📍</span> <strong>Address:</strong>
            <br />
            Rock Town Residents Colony, Mannava Enclave, Chanakyapuri, Hyderabad, Telangana 500068
          </p>
          <p className="contact-detail">
            <span role="img" aria-label="phone">📞</span> <strong>Call Us:</strong>
            <br />
            +91 9281042708
          </p>
          <p className="contact-detail">
            <span role="img" aria-label="email">📧</span> <strong>Mail Info:</strong>
            <br />
            info@shivagangagroup.com
          </p>
          <h3 className="contact-subtitle block animatable bounceIn">About Us</h3>
          <p className="contact-about">
            In 2017, Shri Shiva Ganga Group was started as a project to counter imperfections in the preschool space. With more than 500 happy, “future-ready kids” and counting...
          </p>
        </div>

        {/* Right Section */}
        <div className="contact-form block animatable bounceInRight">
          <h2 className="contact-title block animatable bounceIn">Leave a Message</h2>
          <form>
            <div className="form-group">
              <label htmlFor="name">Your Name*</label>
              <input type="text" id="name" placeholder="Enter Name" required />
            </div>
            <div className="form-group">
              <label htmlFor="email">Your Email*</label>
              <input type="email" id="email" placeholder="Enter Your Email ID" required />
            </div>
            <div className="form-group">
              <label htmlFor="message">Your Message*</label>
              <textarea id="message" rows="4" placeholder="Describe Your Opinion" required></textarea>
            </div>
            <button type="submit" className="common-button block animatable bounceIn">Send Now</button>
          </form>
        </div>
      </div>
    </>
  );
};

export default Contact;
